/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime.js';
import { CfarEventToJSON, EventToJSON, } from '../models/index.js';
/**
 *
 */
export class AnalyticsApi extends runtime.BaseAPI {
    /**
     * Events can also be sent directly from a frontend running on end customer\'s device using the session ID
     * Send a Frontend Event
     */
    postCustomerEventsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.cfarEvent === null || requestParameters.cfarEvent === undefined) {
                throw new runtime.RequiredError('cfarEvent', 'Required parameter requestParameters.cfarEvent was null or undefined when calling postCustomerEvents.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/events`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CfarEventToJSON(requestParameters.cfarEvent),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Events can also be sent directly from a frontend running on end customer\'s device using the session ID
     * Send a Frontend Event
     */
    postCustomerEvents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.postCustomerEventsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Events can be send directly from partner backend using the same authentication as the other endpoints
     * Send a Backend Event
     */
    postEventsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.hCSessionID === null || requestParameters.hCSessionID === undefined) {
                throw new runtime.RequiredError('hCSessionID', 'Required parameter requestParameters.hCSessionID was null or undefined when calling postEvents.');
            }
            if (requestParameters.event === null || requestParameters.event === undefined) {
                throw new runtime.RequiredError('event', 'Required parameter requestParameters.event was null or undefined when calling postEvents.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("PartnerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/events`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EventToJSON(requestParameters.event),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Events can be send directly from partner backend using the same authentication as the other endpoints
     * Send a Backend Event
     */
    postEvents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.postEventsRaw(requestParameters, initOverrides);
        });
    }
}
